import { render, staticRenderFns } from "./ProformaInvoiceDetails.vue?vue&type=template&id=47e66e93"
import script from "./ProformaInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./ProformaInvoiceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports